<template>
  <div class="builder-search-results">
    <ElementsButtonsButtonGroup v-model="selectedView" :class="`__view-selector --${selectedView}`" :button-items="[{label: 'Grid View', value: 'grid', icon: listViewDarkIcon, selectedIcon: listViewIcon}, {label: 'List View', value: 'list', icon: listView2DarkIcon, selectedIcon: listView2Icon}]" />

    <Transition name="fade">
      <div v-if="selectedView === 'grid'">
        <BuilderSearchResultsGridView />
      </div>
      <div v-else>
        <BuilderSearchResultsListView />
      </div>
    </Transition>
    <!--    <SectionsBuilderFeatured />-->
  </div>
</template>
<script setup lang="ts">
import listViewDarkIcon from 'assets/images/icons/list-view-dark.webp';
import listViewIcon from 'assets/images/icons/list-view.webp';
import listView2DarkIcon from 'assets/images/icons/list-view-2-dark.webp';
import listView2Icon from 'assets/images/icons/list-view-2.webp';
import {Ref} from 'vue';
import {useCompanyStore} from '~/store/company';

const selectedView: Ref<string> = ref('grid');
const {$analyticsTrack} = useNuxtApp();
const companyStore = useCompanyStore();

/**
 * @_WATCHER - selectedView
 */
watch(() => selectedView.value, (newValue, oldValue) => {
  // Trigger analytics event
  if (newValue !== oldValue) {
    // Trigger analytics event
    $analyticsTrack({
      action: 'click',
      property: 'Builder view types',
      entity: 'Builder',
      buttonLabel: newValue,
      buttonAction: `Show ${newValue} view`,
      displayedLocation: 'Builder Search Results',
    });
  }
});

/**
 * @_WATCHER - companyStore.companytData
 */
watch(() => companyStore.companytData, () => {
  triggerSearchAnalyticsEvent();
}, {deep: true});

/**
 * Trigger search analytics event
 */
function triggerSearchAnalyticsEvent () {
  $analyticsTrack({
    action: 'search',
    displayedLocation: 'Builder Search Results',
    entity: 'Listing',
    eventData: {
      searchParams: companyStore.queryOptions,
      resultLength: companyStore.companytData.found,
      showed: companyStore.companytData.hits.length,
      searchResultId: companyStore.requestId,
    },
  });
}
</script>

<style lang="scss">
.builder-search-results {
  background: #fff;

  section {
    padding: 10px 0 60px
  }

  .__view-selector {
    padding: 30px 0;

    .__button-group-full-view {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
